const faqItems = [
  {
    q: '51爆料网的信息来源可靠吗？',
    a: '我们采用多渠道交叉验证机制，所有爆料内容均来自用户投稿、公开信息整理及行业知情人士提供。每条51爆料黑料发布前，团队会进行多方核实，确保信息具备基本可信度。同时，我们明确标注信息来源类型，供读者自行判断。',
  },
  {
    q: '如何区分真实爆料与谣言？',
    a: '51爆料网对每一条黑料内容标注"可信度等级"：实锤（有图/视频/文件佐证）、多方印证（两个以上独立来源）、单一来源（待进一步核实）。读者可通过等级标识快速判断信息可靠性。我们强烈建议读者在转发前核实信息真实性。',
  },
  {
    q: '黑料不打烊是什么意思？',
    a: '"黑料不打烊"是51爆料网的核心理念——我们承诺全年无休、24小时不间断更新。无论何时何地，只要有大瓜出现，我们的团队都会第一时间跟进深扒，确保吃瓜群众不会错过任何一条内幕消息。每日凌晨、午间、晚间三个时段定时刷新。',
  },
  {
    q: '我可以匿名投稿爆料吗？',
    a: '当然可以。51爆料网高度重视投稿者的隐私保护，我们提供完全匿名的投稿通道。您无需注册、无需提供任何个人信息即可提交爆料内容。所有投稿IP地址在存储时进行不可逆加密处理，确保投稿者身份绝对保密。',
  },
  {
    q: '51黑料爆料覆盖哪些领域？',
    a: '目前覆盖娱乐圈明星、网红主播、商界大佬、社会热点四大核心领域。具体包括：明星黑历史、网红翻车事件、企业负面新闻、行业黑幕揭露、社会事件内幕等16个细分话题分类。每日新增爆料内容超过200条，黑料大全持续扩充中。',
  },
  {
    q: '发现不实信息如何处理？',
    a: '如发现平台存在不实信息，可通过"我要爆料"页面提交纠错申请。我们设有专门的审核团队，收到申请后48小时内完成核查。确认不实的内容将立即标注"已辟谣"并展示更正说明。对于恶意造谣内容，我们将永久删除并配合相关处理。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          吃瓜指南
        </h2>

        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                <span className="text-primary-500 font-bold mr-2">Q{idx + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}